import styled from "styled-components";

export const ChartContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  // align-items: center;
`;

export const EUScore = styled.div`
  position: absolute;
  bottom: 111px;
  left: 6px;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #737b7d;
`;

export const CultureIndex = styled.div`
  width: 490px;
  display: flex;
  justify-content: center;
  padding-left: 25px;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #737b7d;
`;
